import React, { useEffect, useState } from 'react'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '../firebase'  // <-- Adjust the import to your Firebase config

const ReservationsList = () => {
  const [reservations, setReservations] = useState([])
  const [expandedId, setExpandedId] = useState(null)

  // Months to display (customize as you wish)
  const months = ["May", "June", "July", "August", "September", "October", "November"]

  // 1) Fetch reservations from Firestore on component mount
  useEffect(() => {
    const fetchReservations = async () => {
      try {
        const snapshot = await getDocs(collection(db, "reservations"))
        const data = snapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data()
        }))
        setReservations(data)
      } catch (error) {
        console.error("Error fetching reservations:", error)
      }
    }
    fetchReservations()
  }, [])

  // Toggle expand/collapse for a specific reservation card
  const toggleExpand = (reservationId) => {
    setExpandedId((prev) => (prev === reservationId ? null : reservationId))
  }

  return (
    <div className="max-w-5xl mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6 text-center">Reservations</h1>

      {reservations.map((res) => {
        const { id, primaryContact, participants, downPayment } = res
        const isExpanded = expandedId === id

        // Log the entire reservation object for debugging
        console.log("Reservation data =>", res)

        return (
          <div
            key={id}
            className="bg-white shadow-md rounded-lg mb-6 transition-colors"
          >
            {/* Card Header: Primary Contact & Down Payment */}
            <button
              onClick={() => toggleExpand(id)}
              className="w-full text-left px-6 py-4 flex items-center justify-between 
                         bg-indigo-100 hover:bg-indigo-200 rounded-t-lg"
            >
              <div className="text-lg font-semibold">
                {primaryContact?.firstName} {primaryContact?.lastName}
              </div>
              <div className="flex flex-col text-sm text-gray-700 items-end">
                <span>
                  {/* Show the overall group's down payment status */}
                  Down Payment:{" "}
                  {downPayment ? (
                    <span className="text-green-600 font-bold">Paid</span>
                  ) : (
                    <span className="text-red-500 font-semibold">Not Paid</span>
                  )}
                </span>
                <span className="text-gray-600">
                  {isExpanded ? "Click to collapse" : "Click to expand"}
                </span>
              </div>
            </button>

            {/* Expandable Content: Participants & Payment Table */}
            {isExpanded && (
              <div className="p-6">
                <h2 className="text-xl font-semibold mb-4">Participants</h2>
                {participants && participants.length > 0 ? (
                  <div className="overflow-x-auto">
                    <table className="min-w-full border-collapse">
                      <thead>
                        <tr className="bg-indigo-600 text-white">
                          <th className="border px-4 py-2">Name</th>
                          <th className="border px-4 py-2">Email</th>
                          <th className="border px-4 py-2">Phone</th>
                          <th className="border px-4 py-2">Initial Payment</th>
                          {months.map((month) => (
                            <th key={month} className="border px-4 py-2">
                              {month}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {participants.map((participant) => {
                          // Log each participant for debugging
                          console.log("Participant data =>", participant)

                          return (
                            <tr
                              key={participant.id}
                              className="text-center hover:bg-gray-50"
                            >
                              {/* Name */}
                              <td className="border px-4 py-2 font-medium text-gray-800">
                                {participant.firstName} {participant.lastName}
                              </td>

                              {/* Email */}
                              <td className="border px-4 py-2">
                                {participant.email}
                              </td>

                              {/* Phone */}
                              <td className="border px-4 py-2">
                                {participant.phone}
                              </td>

                              {/* Initial Payment Status */}
                              <td className="border px-4 py-2">
                                {participant.initialPayment ? (
                                  <span className="text-green-600 font-bold">Paid</span>
                                ) : (
                                  <span className="text-red-500 font-semibold">Not Paid</span>
                                )}
                              </td>

                              {/* Monthly Payment Statuses */}
                              {months.map((month) => {
                                const paid = participant.payments?.[month]
                                return (
                                  <td key={month} className="border px-4 py-2">
                                    {paid ? (
                                      <span className="text-green-600 font-bold">Paid</span>
                                    ) : (
                                      <span className="text-red-500 font-semibold">
                                        Not Paid
                                      </span>
                                    )}
                                  </td>
                                )
                              })}
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-gray-600">No participants found.</p>
                )}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default ReservationsList
